import React from 'react';
import { Link } from 'react-router-dom';
import './RefundExchangeFallback.scss';

function RefundExchangeFallback() {
    return (
        <div className="re-container display-flex">
            <div className="logo">
                <Link to="/">
                    <img src="https://static1.lenskart.com/media/desktop/img/site-images/logo.svg" alt="lk" />
                </Link>
            </div>
            <div className="info text-black text-center bg-color-white">
                <div className="font-medium fs20 margin-b8">
                    Want to Exchange/refund your product?
                </div>
                <div className="font-medium fs20 margin-b8">
                    Download our mobile app
                </div>
                <div className="fs16">
                    Go to App ⟩ My Accounts section
                </div>
                <div className="app-icons margin-t30 display-flex">
                    <a href="https://onelink.to/lenskart2"><img className="app-icon" src="https://static.lenskart.com/media/desktop/img/site-images/applestore.svg" alt="as" /></a>
                    <a href="https://onelink.to/lenskart2"><img className="app-icon" src="https://static.lenskart.com/media/desktop/img/site-images/googleplay.svg" alt="ps" /></a>
                </div>
            </div>
            <Link to="/" className="home-link margin-t10 fs14">Go to Lenskart.com</Link>
        </div>
    );
}

export default RefundExchangeFallback;
